import React, {FC} from 'react';
import {Outlet} from 'react-router-native';
import {useApp} from '@app';
import {AuthRedirect} from './AutomaticRedirects';

const RequireGuest: FC = () => {
  const {authorization} = useApp();

  return authorization ? <AuthRedirect /> : <Outlet />;
};

export {RequireGuest};
